import React, { useEffect, useState } from 'react'
import StudentInfoCard from './StudentInfoCard'
import '../../styles/manager/student-info-box.css'
import MantineSelectBox from '../common/MantineSelectBox'
import SaveButton from '../common/SaveButton'
import { useLocation } from 'react-router-dom'
import { apiRequest } from '../../utils/api'
import { useAuthStore } from '../../store'

const StudentInfoBox = () => {
  const location = useLocation()
  const user = useAuthStore((state) => state.user)
  const selectedLevel = location.state?.level
  const [studentData, setStudentData] = useState([])
  const [NAME, setNAME] = useState('')
  const [LEVEL, setLEVEL] = useState(selectedLevel)

  const LEVELDATA = [
    { value: '1', label: 'LEVEL 1' },
    { value: '2', label: 'LEVEL 2' },
    { value: '3', label: 'LEVEL 3' },
    { value: '4', label: 'LEVEL 4' },
    { value: '5', label: 'LEVEL 5' },
    { value: '6', label: 'LEVEL 6' },
    { value: '7', label: 'LEVEL 7' },
    { value: '8', label: 'LEVEL 8' },
    { value: '9', label: 'LEVEL 9' },
    { value: '10', label: 'LEVEL 10' },
    { value: '11', label: 'LEVEL 11' },
    { value: '12', label: 'LEVEL 12' },
  ]

  useEffect(() => {
    fetchStudentCard(selectedLevel)

  }, [selectedLevel])

  const fetchStudentCard = async (selectedLevel) => {
    try {
      const res = await apiRequest('/fetchStudentCard', 'POST',{
        LEVEL : LEVEL ,
        CENTER : user.CENTER_ID || 'all' ,
        NAME : NAME
      })
      if (res.data) {
        setStudentData(res.data)
      } else {
        throw new Error('조회 실패')
      }
    } catch (err) {
    }
  }

  return (
    <div className="box-container">
      <div className="uploads-search-section">
        <div className="search-section">
          <input
            className="search-input"
            placeholder="Name"
            value={NAME}
            onChange={(e) => setNAME(e.target.value)}
          />
          <MantineSelectBox
            value={LEVEL}
            data={LEVELDATA}
            onChange={setLEVEL}
            width='200px'
          />
        </div>
        <div className="search-buttons">
          <SaveButton className="update-button" onClick={() => (
            setNAME(''),
            setLEVEL(selectedLevel)
          )}>
            Reset
          </SaveButton>
          <SaveButton onClick={fetchStudentCard}>Search</SaveButton>
        </div>
      </div>
      <div className="info-card-grid">
        {studentData.map((student) => (
          <StudentInfoCard
            key={student.id}
            avatar={<img src={student.avatar} alt="Monster" />}
            name={student.name}
            level={student.level}
            progress={student.progress}
          />
        ))}
      </div>
    </div>
  )
}

export default StudentInfoBox
